const STORAGE_KEY = '@eskolare/popup-engagement';

const DISMISS_COOLDOWN_DAYS = 7;
const MAX_DISMISS_COUNT = 3;

const DEFAULT_ENGAGEMENT = { dismissCount: 0, lastDismissedAt: null, convertedAt: null };

const hasStorage = () => {
  try {
    return typeof window !== 'undefined' && !!window.localStorage;
  } catch (error) {
    return false;
  }
};

export function getEngagementMap() {
  if (!hasStorage()) return {};
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('Erro ao ler engajamento de popups do localStorage', error);
    return {};
  }
}

function writeAll(map) {
  if (!hasStorage()) return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('Erro ao salvar engajamento de popups no localStorage', error);
  }
}

function getEngagement(uid) {
  return { ...DEFAULT_ENGAGEMENT, ...getEngagementMap()[uid] };
}

export function isEngagementSuppressed(engagement, now = new Date()) {
  const { dismissCount, lastDismissedAt, convertedAt } = engagement || DEFAULT_ENGAGEMENT;

  if (convertedAt) return true;
  if (dismissCount >= MAX_DISMISS_COUNT) return true;

  if (dismissCount > 0 && lastDismissedAt) {
    const cooldownEndsAt =
      new Date(lastDismissedAt).getTime() + DISMISS_COOLDOWN_DAYS * 24 * 60 * 60 * 1000;
    return now.getTime() < cooldownEndsAt;
  }

  return false;
}

function updateEngagement(uid, changes) {
  const all = getEngagementMap();
  all[uid] = { ...DEFAULT_ENGAGEMENT, ...all[uid], ...changes };
  writeAll(all);
  return all[uid];
}

export function registerDismiss(uid) {
  const current = getEngagement(uid);
  return updateEngagement(uid, {
    dismissCount: current.dismissCount + 1,
    lastDismissedAt: new Date().toISOString(),
  });
}

export function registerConversion(uid) {
  return updateEngagement(uid, { convertedAt: new Date().toISOString() });
}
